import { FC } from 'react'
import { AlertData } from '../../../interfaces'
import { alerts } from '../../../utils/constants'
import { MenuItem, Badge, Box, Typography, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import './VitalAlerts.css'

interface AlertItemProps {
  item: AlertData
  index: number
  removeAlert: (e: React.MouseEvent<HTMLButtonElement>, index: number) => void
  handleAlertItemClick: (index: number, muhid: string, location: string) => void
}

const AlertItem: FC<AlertItemProps> = ({
  item,
  index,
  removeAlert,
  handleAlertItemClick,
}) => {
  const getAlarmValue = (alarmValue: string) => {
    if (alarmValue === alerts?.higherThanLimit) return alerts?.high
    else if (alarmValue === alerts?.lowerThanLimit) return alerts?.low
    else return alarmValue
  }

  return (
    <MenuItem
      id={crypto.randomUUID()}
      className={`alert-details-container ${item?.isClicked ? 'clicked' : ''}`}
    >
      <Badge
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        badgeContent={item?.count}
        color='primary'
        className='alert-badge'
      ></Badge>
      <Box
        className='alert-details'
        onClick={() => handleAlertItemClick(index, item?.muhid, item?.location)}
      >
        <Box>
          <Typography className='alert-subDetails' variant='body2'>
            {item?.muhid}
          </Typography>
          <Typography className='alert-subDetails' variant='body2'>
            {item?.location}
          </Typography>
        </Box>
        <Box>
          <Typography variant='body2' className='alert-vitals'>
            {item?.vitals}&nbsp;:&nbsp;{item?.value}
          </Typography>
        </Box>
        <Box>
          {item?.value_limit && (
            <Typography
              variant='body2'
              className={
                item?.value_limit === alerts?.higherThanLimit ||
                item?.value_limit === alerts?.lowerThanLimit
                  ? 'alert-vitals-for-normal'
                  : 'alert-vitals-for-extreme'
              }
            >
              {getAlarmValue(item?.value_limit)}
            </Typography>
          )}
        </Box>
      </Box>
      <IconButton
        aria-label='remove-alert'
        onClick={(e) => removeAlert(e, index)}
      >
        <CloseIcon className='close-icon' />
      </IconButton>
    </MenuItem>
  )
}

export default AlertItem
